jQuery( function() {
    // Homepage Main Top Image Carousel
    if ( jQuery( '.owl-carousel.home--slider' ).length > 0 ) {
        jQuery( '.owl-carousel.home--slider' ).owlCarousel( {
            loop: true,
            responsiveClass: true,
            margin: 60,
            dots: false,
            nav: false,
            autoplay: true,
            navText: ["<img src='wp-content/themes/afs-theme/assets/images/left.png'>", "<img src='wp-content/themes/afs-theme/assets/images/right.png'>"],
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 1
                },
                1000: {
                    items: 1
                }
            }
        } );
    }
} );
